<template>
  <div class="content">
    <div class="banner">
      <img :src="getBanner" alt="banner" />
    </div>
    <PageHeader v-if="!isHome" title="返回" @back="back" />
    <div class="topTitle">
      <h2>{{ getReceiptName }}</h2>
      <p>{{ getReceiptSubName }}</p>
    </div>

    <keep-alive :include="['Retrieve']">
      <router-view />
    </keep-alive>
    <div class="footer"><img :src="getFooter" alt="" /></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Banner from "@/assets/img/banner.png";
import Footer from "@/assets/img/footer.png";
import PageHeader from "@/components/PageHeader.vue";
export default {
  components: {
    PageHeader,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      config: "receiptStore/getConfig",
    }),
    getReceiptName() {
      return this.config.receiptName || "凭证找回";
    },
    getReceiptSubName() {
      return this.config.receiptSubName || "Recovery of Voucher";
    },
    getBanner() {
      return this.config.banner || Banner;
    },
    getFooter() {
      return this.config.footer || Footer;
    },
    isHome() {
      return this.$route.path === "/receipt/retrieve";
    },
  },
  methods: {
    back() {
      if (!this.isHome) {
        localStorage.clear();
        this.$router.back();
      }
    },
  },
};
</script>
